import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class MaskLocalizationManager {
  constructor() {
    /** @type {string} */
    this._stringPath = 'assets/';

    this._localizedStrings = {};
  }

  /**
   * @param {string} path
   */
  set stringPath(path) {
    this._stringPath = path ?? 'assets/';
  }

  /**
   * Loads the Spanish strings file. This function should be called from a scene's preloader function.
   * @param {Phaser.Scene} scene 
   * @returns this
   */
  loadLocalizedAssets(scene) {
    scene.load.json('mask-localization-strings', `${this._stringPath}es-US/strings.json`);
    scene.load.once(`${Phaser.Loader.Events.FILE_KEY_COMPLETE}json-mask-localization-strings`, (key, type, data) => {
      // merge the localized strings with the default strings
      this._localizedStrings = data;

      // delete the json from the cache as it's no longer needed
      scene.cache.json.remove('mask-localization-strings');
    });
    scene.load.on(Phaser.Loader.Events.FILE_LOAD_ERROR, (file) => {
      if (file.type === 'json' && file.key === 'localization-strings' && this._stringPath !== 'assets/') {
        this._stringPath = 'assets/';

        // the strings JSON file failed to load, if we were using the path override, load it locally instead
        scene.load.json('mask-localization-strings', `${this._stringPath}es-US/strings.json`);
      }
    });

    return this;
  }

  /**
   * Gets the localized version of the desired string.
   * @param {string} key the key of the string to return
   * @param {boolean} isDefault whether you want to get the string for the default locale (the locale managed by the ABCyaPhaser.LocalizationManager) or for the Spanish locale
   * @returns {string} the localized string, or an empty string if the key does not exist in the lookup table
   */
  getLocalizedString(key, isDefault) {
    if (isDefault) {
      return ABCyaPhaser.Localization.instance.getLocalizedString(key);
    }

    let returnString = this._localizedStrings[key];
    let warningMessage = `The key "${key}" was not found in the strings dictionary.`;

    if (key.includes('.')) {
      const split = key.split('.');
      let currentSection = '';

      returnString = this._localizedStrings;

      split.every((section, index) => {
        if (index > 0) {
          currentSection += '.';
        }
        currentSection += section;
        warningMessage = `The key up to "${currentSection}" was not found in the strings dictionary.`;
        returnString = returnString[section];
        return returnString !== undefined;
      });
    }

    if (typeof returnString !== 'string' && returnString !== undefined) {
      warningMessage = `The key "${key} returned an object instead of a string, please check string file`;
      returnString = undefined;
    }

    if (returnString === undefined) {
      console.warn(warningMessage);
    }

    return returnString ?? '';
  }
}